export default "__VITE_ASSET__df71a80e__"